import { parse } from './common'
import { raw } from './raw'

const parseText = <R>(response: Response): Promise<R> =>
  response.text() as Promise<R>

export const html = async (
  url: URL | RequestInfo,
  options: RequestInit = {}
): Promise<string | null> => {
  options.headers = {
    Accept: 'text/html',
    ...options.headers,
  }

  const response = await raw(url, options)
  return parse<string>(parseText)(response)
}
